import React from "react";
import { Navigate } from "react-router-dom";
import useAcl from "../../hooks/useAcl";

interface ProtectedProjectRouteProps {
  children: React.ReactNode;
}

const ProtectedProjectRoute: React.FC<ProtectedProjectRouteProps> = ({
  children,
}) => {
  const { canRead } = useAcl("Project");

  if (canRead === false) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedProjectRoute;
